import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'

import App from './App.vue'
import store from './store'
import router from './router'

import './registerServiceWorker'

// Global Components
import './global-components'

// 3rd party plugins
import '@axios'
import '@/libs/portal-vue'
import '@/libs/toastification'
import '@/libs/sweet-alerts'

// CouchDB
import PouchDB from 'pouchdb'
import Find from 'pouchdb-find'
// import LiveFind from 'pouchdb-live-find'
import PouchdbAuthentication from 'pouchdb-authentication'
PouchDB.plugin(Find)
// PouchDB.plugin(LiveFind)
PouchDB.plugin(PouchdbAuthentication)

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)

// Composition API
Vue.use(VueCompositionAPI)


// Feather font icon - For form-wizard
// * Shall remove it if not using font-icons of feather-icons - For form-wizard
require('@core/assets/fonts/feather/iconfont.css') // For form-wizar

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false

// global variable
Vue.prototype.$invoice = Vue.observable({
  client: {
    adresseLivraison : '',
    adresseFacturation : '',
    modepaiement: '',
    email: '',
    eligibleTVA: '',
    contact: '',
  },
  products: [],
  totalmontant: 0,
  totalmontanttva: 0,
  totalmontantttc: 0,
  totalfraisport: 0,
  totalPaire: 0,
  remisepanier: 0,
  consent: '',
  note: '',
  nomcommercial: '',
  commercial: '',
  telcommercial : ''
})


new Vue({
  router,
  store,
  created() {
    // Prevent blank screen in Electron builds
    // this.$router.push('/')
    this.$router.push({ path: this.$route.path })
  },
  render: h => h(App),
}).$mount('#app')
